import { Image } from '@type-declarations/media';

interface Props {
  image: Image;
  focusPoint?: string;
}

export const getImageAlignment = ({ image, focusPoint }: Props) => {
  if (image) {
    if (image.focalPoint) {
      return `${image.focalPoint.x}% ${image.focalPoint.y}%`;
    }

    return focusPoint;
  }

  return 'center center';
};
